import { render, staticRenderFns } from "./GalleryC.vue?vue&type=template&id=1ea4b65e&"
import script from "./GalleryC.vue?vue&type=script&lang=js&"
export * from "./GalleryC.vue?vue&type=script&lang=js&"
import style0 from "./GalleryC.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports